import React from "react";
import moment from "moment";
import calender from "assets/images/icons/calendar-icon-dark-grey.svg";
import holding from "assets/images/icons/initialHolding.svg";

export const CourseTaskTrading = ({ startDate, endDate, initialHolding }) => {
  startDate = moment(startDate, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY");
  endDate = endDate
    ? moment(endDate, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY")
    : "";
  return (
    <div className="trading mt-4 course-view-div">
      <div className="d-flex align-items-center gap-4">
        <div>
          <div className="d-flex align-items-center gap-1 trading">
            <img src={calender} alt="Start Date" />

            <p className="mb-0 trading-info">Start Date</p>
          </div>
          <p className="mt-1 ps-4 fw-normal">{startDate}</p>
        </div>
        {endDate && (
          <div>
            <div className="d-flex align-items-center gap-1 trading">
              <img src={calender} alt="Start Date" />

              <p className="mb-0 trading-info">End Date</p>
            </div>
            <p className="mt-1 ps-4 fw-normal">{endDate}</p>
          </div>
        )}
        <div>
          <div className="d-flex align-items-center gap-1 trading">
            <img src={holding} alt="Start Date" />

            <p className="mb-0 trading-info">Initial Holding</p>
          </div>
          <p className="mt-1 ps-4 fw-normal">
            ₹{new Intl.NumberFormat("en-IN").format(initialHolding)}
          </p>
        </div>
      </div>
    </div>
  );
};
